import { AppLayout } from "@/components/layout/AppLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, MessageCircle } from "lucide-react";
import { LeaveFeedbackCard } from "@/components/settings/LeaveFeedbackCard";

const Support = () => {
  return (
    <AppLayout>
      <div className="p-4 md:p-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Support</h1>
          <p className="text-muted-foreground mt-1">We're here to help</p>
        </div>

        <Card className="max-w-2xl">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <MessageCircle className="h-5 w-5" />
              Get in Touch
            </CardTitle>
            <CardDescription>
              Have questions, feedback, or just want to chat?
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-muted-foreground">
              We'd love to hear from you! Whether you have a question about using HostCaptain, 
              want to share feedback, or simply want to say hello, don't hesitate to reach out.
            </p>
            
            <div className="flex items-center gap-3 p-4 bg-muted rounded-lg">
              <Mail className="h-5 w-5 text-primary" />
              <div>
                <p className="text-sm text-muted-foreground">Email us at</p>
                <a 
                  href="mailto:support@hostcaptain.co" 
                  className="text-primary font-medium hover:underline"
                >
                  support@hostcaptain.co
                </a>
              </div>
            </div>

            <p className="text-sm text-muted-foreground">
              We typically respond within 24-48 hours.
            </p>
          </CardContent>
        </Card>

        <div className="max-w-2xl">
          <LeaveFeedbackCard />
        </div>
      </div>
    </AppLayout>
  );
};

export default Support;
